import GoogleTagManager from '@redux-beacon/google-tag-manager'
import { handleFreshToken, logout, showCheggAuthModal } from '@src/state/auth/actions'
import {
  checkResults,
  checkStart,
  runChecks,
  updateCardState,
} from '@src/state/checks/actions'
import {
  copyText,
  downloadPaper,
  onClickNavLink,
  openExternalLink,
  seeSources,
  setActiveEntityKey,
  textCopied,
} from '@src/state/document/actions'
import {
  accountCtaEvents,
  authModalEvent,
  categoryChangeEvent,
  checkErrorEvent,
  copyPaperEvent,
  deletePaperEvent,
  downloadPaperEvent,
  expertCheckTicketEvent,
  handleFreeTrialStartEvent,
  hardRedirectEvent,
  localeSwitcherEvent,
  locationChangeEvent,
  loginEvent,
  logoutEvent,
  onTopNavHeaderClickEvent,
  openExternalLinkEvent,
  plagiarismCheckEvent,
  runChecksEvent,
  seeSourcesEvent,
  setActiveEntityKeyEvent,
  showModalEvent,
  textCopiedEvent,
  updateCardEvent,
  userInteractEvent,
} from '@src/state/gtm/definitions'
import { showModal } from '@src/state/modals/actions'
import { handleFreeTrialStart } from '@src/state/payment/actions'
import { LOCATION_CHANGE } from 'connected-react-router'
import { createMiddleware, EventsMapper } from 'redux-beacon'
import { getType } from 'typesafe-actions'
import { createTicketSuccess } from '../expertcheck/actions'
import { deletePaper } from '../papers/actions'
import { userInteract } from '../userevents/actions'
import { hardRedirect, setCurrentCategory, switchLocale } from '../workspace/actions'

const gtm = GoogleTagManager()

export const eventsMap: EventsMapper = action => {
  if (!(window as any).dataLayer) {
    return []
  }
  switch (action.type) {
    // case getType(createTicketFailure): TODO: enable once we want to collect failures
    case getType(createTicketSuccess): {
      return expertCheckTicketEvent
    }
    case getType(showModal): {
      return showModalEvent
    }
    case getType(showCheggAuthModal): {
      return [authModalEvent, accountCtaEvents]
    }
    case getType(logout): {
      return logoutEvent
    }
    case getType(handleFreshToken): {
      return loginEvent
    }
    case getType(runChecks): {
      return runChecksEvent
    }
    case getType(checkStart): {
      return plagiarismCheckEvent
    }
    case getType(handleFreeTrialStart): {
      return handleFreeTrialStartEvent
    }
    case LOCATION_CHANGE: {
      return locationChangeEvent
    }
    case getType(updateCardState): {
      return updateCardEvent
    }
    case getType(setActiveEntityKey): {
      return setActiveEntityKeyEvent
    }
    case getType(checkResults.failure): {
      return checkErrorEvent
    }
    case getType(deletePaper.request): {
      return deletePaperEvent
    }
    case getType(openExternalLink): {
      return openExternalLinkEvent
    }
    case getType(copyText): {
      return copyPaperEvent
    }
    case getType(downloadPaper): {
      return downloadPaperEvent
    }
    case getType(setCurrentCategory): {
      return categoryChangeEvent
    }
    case getType(hardRedirect): {
      return hardRedirectEvent
    }
    case getType(seeSources): {
      return seeSourcesEvent
    }
    case getType(textCopied): {
      return textCopiedEvent
    }
    case getType(switchLocale): {
      return localeSwitcherEvent
    }
    case getType(onClickNavLink): {
      return onTopNavHeaderClickEvent
    }
    case getType(userInteract): {
      return userInteractEvent
    }
    default:
      return []
  }
}

export const gaMiddleware = createMiddleware(eventsMap, gtm)



// WEBPACK FOOTER //
// ./src/state/gtm/index.ts